import React, { FC } from "react";
import ZIcon from "../ZIcon/ZIcon";
import { getPaginationRange } from "./helper";
import styled from "styled-components";
import variables from "../../../../constants/assets/variables";

const DOTS = "...";

const Pagination = ({
  onPageChange,
  totalCount,
  siblingCount = 1,
  currentPage,
  pageSize = 1,
  className,
}) => {
  const styles = {
    pagination_container: "flex justify-center items-center gap-2",
    pagination_item:
      "flex justify-center items-center w-5 h-5 rounded-full cursor-pointer text-xs hover:bg-gray-200",
    selected: "bg-red-500 text-white hover:bg-red-500",
    disabled: "opacity-50 cursor-not-allowed",
    dots: "flex justify-center items-center w-2 h-2 rounded-full",
  };

  const paginationRange = getPaginationRange(
    currentPage,
    totalCount,
    siblingCount,
    pageSize
  );

  if (currentPage === 0 || paginationRange?.length < 2) {
    return null;
  }

  let lastPage =
    paginationRange && paginationRange[paginationRange?.length - 1];

  const onNext = () => {
    if (currentPage === lastPage) return;
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    if (currentPage === 1) return;
    onPageChange(currentPage - 1);
  };

  return (
    <PaginationContainer className={className}>
      <PaginationIcon
        unicode="e92e"
        className={`mr-1 text-lg ${currentPage === 1 ? styles.disabled : ""} `}
        onClick={onPrevious}
      />
      {paginationRange?.map((pageNumber, index) => {
        if (pageNumber === DOTS) {
          return <Dots key={index}>...</Dots>;
        }

        return (
          <PaginationItem
            className={` ${pageNumber == currentPage ? "selected" : ""}`}
            onClick={() => onPageChange(pageNumber)}
            key={index}
          >
            {pageNumber}
          </PaginationItem>
        );
      })}
      <PaginationIcon
        unicode="e92f"
        className={`${currentPage === lastPage ? "disabled" : ""}`}
        onClick={onNext}
      />
    </PaginationContainer>
  );
};

export default Pagination;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

const PaginationItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 12px !important;
  font-weight: 500;

  &:hover {
    background-color: #f3f4f6;
  }

  &.selected {
    background-color: ${variables.red500};
    color: white;
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const Dots = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
`;

const PaginationIcon = styled(ZIcon)`
  font-size: 16px;
  cursor: pointer;

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
